import { Table, TableBody, TableHead, TableRow } from '@mui/material';

import ClientPaginatedTable from '../table/ClientPaginatedTable';
import GeneralTableBox from '../table/GeneralTableBox';
import RowTableCell from '../table/RowTableCell';
import SortableHeadTableCell from '../table/SortableHeadTableCell';
import NoDataSkeleton from '../skeletons/NoDataSkeleton';
import { useTableSort } from '../../hooks/useTableSort';
import { MATERIAL_TABLE_TEXTS } from './materialPresentationConstants';
import { materialCell } from '../../../utils/materialDisplay';
import { sortRows } from '../../../utils/sortRows';

const COLUMNS = [
  {
    key: 'received_at',
    label: MATERIAL_TABLE_TEXTS.receipt,
    sx: { textAlign: 'left', width: 200 },
  },
  {
    key: 'quantity',
    label: MATERIAL_TABLE_TEXTS.acceptedQuantity,
    sx: { textAlign: 'right', width: 180 },
  },
  { key: 'document', label: MATERIAL_TABLE_TEXTS.document, sx: { textAlign: 'left' } },
];

/**
 * Recepciones y remitos de un pedido a proveedor, ordenables por columna.
 * @param {Object} props
 * @param {Array<Object>} [props.receipts] Recepciones confirmadas del renglón.
 * @returns {JSX.Element}
 */
const MaterialReceiptsTable = ({ receipts = [] }) => {
  const { sort, toggleSort } = useTableSort();
  const rows = sortRows(receipts, sort);

  return (
    <ClientPaginatedTable rows={rows} resetKey={`${sort?.key}:${sort?.direction}`}>
      {(pageRows) => (
        <GeneralTableBox hasMaxHeight={false} fixedLayout>
          <Table size="small">
            <TableHead>
              <TableRow>
                {COLUMNS.map((column) => (
                  <SortableHeadTableCell
                    key={column.key}
                    sortKey={column.key}
                    sort={sort}
                    onSort={toggleSort}
                    sx={column.sx}
                  >
                    {column.label}
                  </SortableHeadTableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.length ? (
                pageRows.map((receipt, index) => (
                  <TableRow key={`${receipt.received_at}:${index}`} hover>
                    <RowTableCell sx={{ textAlign: 'left' }}>
                      {materialCell('received_at', receipt.received_at)}
                    </RowTableCell>
                    <RowTableCell sx={{ textAlign: 'right' }}>
                      {materialCell('quantity', receipt.quantity)}
                    </RowTableCell>
                    <RowTableCell sx={{ textAlign: 'left' }}>
                      {receipt.document || MATERIAL_TABLE_TEXTS.noDocument}
                    </RowTableCell>
                  </TableRow>
                ))
              ) : (
                <NoDataSkeleton
                  colSpan={COLUMNS.length}
                  message={MATERIAL_TABLE_TEXTS.noReceipts}
                  showSubtitle={false}
                />
              )}
            </TableBody>
          </Table>
        </GeneralTableBox>
      )}
    </ClientPaginatedTable>
  );
};

export default MaterialReceiptsTable;
